import ProductImageUpload from "./ProductImageUpload";

import "./ProductImageUpload.scss";

export * from "./ProductImageUpload.types";

export { ProductImageUpload };
